import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import QueueView from '../views/QueueView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/',
    name: 'slash',
    component: () => import('../views/Auth.vue')
  },
  {
    path: "/authen",
    name: "authen",
    component: () => import("../views/Authentication.vue"),
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/user",
    name: "user",
    component: () => import("../views/User.vue"),
  },
  {
    path: "/queue_detail/:id",
    name: "queue_detail",
    component: () => import("../views/QueueDetail.vue"),
  },
  {
    path: "/history",
    name: "history",
    component: () => import("../views/History.vue"),
  },
  {
    path: "/dateoff",
    name: "dateoff",
    component: () => import("../views/Dateoff.vue"),
  },
  {
    path: "/report_excel",
    name: "report_excel",
    component: () => import("../views/ReportExcel.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/Logout.vue"),
  }, 
  {
    path: "/meeting/:id",
    name: "meeting",
    component: () => import("../views/Meeting.vue"),
  },
  {
    path: "/leave_meeting/:id",
    name: "leave_meeting",
    component: () => import("../views/LeaveMeeting.vue"),
    
  },
]

const router = new VueRouter({
  mode: 'history',  
  base: window.location.host == "localhost:8080"
  ? "/"
  : "/",
  routes
})

export default router
